<template >

  <div class="overflow" v-if="isDisplaySidebar" @click="hideSidebar"></div>
  <div class="sidebar noPrint" :style="{ width: sidebarWidth }" :class="isDisplaySidebar ? 'show' : '' " > <!--v-if="isDisplaySidebar"-->


    <!-- <h1 class="name-web">
      <span v-if="collapsed">
        <div>{{ $t('_public._name_app_a') }}</div>
        <div>{{ $t('_public._name_app_b') }}</div>
      </span>
      <span v-else>{{ $t('_public._name_app') }}</span>
    </h1> -->


    <!-- <p class="title-settings">مزيد من الوظائف</p> -->

    <p class="title-box-links">{{ $t('_sidebar._Essential') }}</p>
    <div class="box-links">
      <SidebarLink to="/" icon="home-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Home') }}</SidebarLink>
      <SidebarLink to="/categories/all" icon="grid-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Categories') }}</SidebarLink>
      <SidebarLink v-if="isLogin === 'yes'" to="/orders" icon="bag-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Orders') }}</SidebarLink>
      <SidebarLink v-if="isLogin === 'yes'" to="/favorite" icon="heart-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Favorite') }}</SidebarLink>
    </div>

    <p class="title-box-links">{{ $t('_sidebar._Transfers') }}</p>
    <div class="box-links">
      <SidebarLink to="/wallet" icon="wallet-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Wallet') }}</SidebarLink>
      <SidebarLink to="/my-wallet-address" icon="qr-code-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Wallet_Address') }}</SidebarLink>
      <SidebarLink to="/send-internal-transfer" icon="navigate-outline" site="top" @click="hideSidebar">{{ $t('_wallet._Send') }}</SidebarLink>
      <!-- <SidebarLink to="/send-external-transfer" icon="rocket-outline" site="top" @click="hideSidebar">{{ $t('_wallet._Transfer') }}</SidebarLink> -->

    </div>

    <p class="title-box-links">{{ $t('_sidebar._Top_Credit') }}</p>
    <div class="box-links">
      <SidebarLink to="/authorized-agents" icon="people-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Authorized_Agents') }}</SidebarLink>
      <SidebarLink to="/charging-methods" icon="wallet-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Charging_Methods') }}</SidebarLink>
      <SidebarLink to="/card" icon="card-outline" site="top" @click="hideSidebar">{{ $t('_public._redeem_code') }}</SidebarLink>

    </div>

    <p class="title-box-links">{{ $t('_sidebar._My_Account') }}</p>
    <div class="box-links">
      <SidebarLink v-if="isLogin === 'yes'" to="/profile" icon="person-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Profile') }}</SidebarLink>
      <SidebarLink v-if="isLogin === 'yes'" to="/activity" icon="document-text-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Activity') }}</SidebarLink>
      <SidebarLink v-if="isAPI === true" to="/api" icon="hardware-chip-outline" site="top" @click="hideSidebar">API</SidebarLink>
      <SidebarLink v-if="isLogin === 'yes'" to="/logout" icon="log-out-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Logout') }}</SidebarLink>
      <SidebarLink v-if="isLogin === 'no'" to="/login" icon="log-in-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._Login') }}</SidebarLink>
    </div>

    <p class="title-box-links">{{ $t('_sidebar._Others') }}</p>
    <div class="box-links">
      <SidebarLink to="/about" icon="settings-outline" site="top" @click="hideSidebar">{{ $t('_sidebar._About') }}</SidebarLink>
    </div>


    <!-- <span class="collapse-icon" :class="{ 'rotate-180': collapsed }" @click="toggleSidebar">X</span> -->
  </div>
</template>
  
<script>
import SidebarLink from './SidebarLink';
import { collapsed, toggleSidebar, sidebarWidth, isDisplaySidebar, hideSidebar} from './state';
import myUser from '../../myUser';
import axios from 'axios';

export default {
  name: 'SideBar',
  props: {
    msg: String
  },
  data() {

    return {
      isLogin: myUser.isLogin,
      isAPI: false
    }
  },
  methods: {
    async checkAPIUser(){
      // this.isLoading = false;
      const inputs = {'idus': myUser.id_user, 'token': myUser.token} 
      await axios.postForm('app_settings.php?action=checkAPIUser', inputs).then((res) => {
        // console.log(res['data'])
        if (res['data']['msg'] == 'ok') {
          this.isAPI = true;
        } else {
          this.isAPI = false;
        }
      }).catch(() => {  });
    },
    
    hideSidebar(){
      hideSidebar();
    }
    // checkLogin(){
    //   this.isLogin = false
    //   // return true
    // }
  },
  mounted(){
    this.checkAPIUser()
  },
  components: { 
    SidebarLink,
  },
  setup(){
    return { collapsed, toggleSidebar, sidebarWidth, isDisplaySidebar }
  }
}
</script>

<style scoped>
.overflow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(var(--public-rgb), .2);
  z-index: 10000;
}
.sidebar {
  color: var(--color-text);
  /* background-color: var(--sidebar-bg-color); */
  background-color: var(--box-background);
  float: left;
  position: fixed;
  z-index: 10001;
  top: 0;
  left: -400px;
  bottom: 0;
  padding: 0.5em;

  transition: 0.4s ease;

  /* display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: flex-start; */
  text-align: start;
  height: 100vh;
}
.sidebar.show {
  left: 0px;
  transition: 0.4s ease;
}
.sidebar .box-links {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.sidebar .name-web {
  font-size: 16px;
  margin: 26px 0px;
  margin-bottom: 26px !important;
  text-transform: uppercase;
}
.collapse-icon {
  position: absolute;
  bottom: 0;
  padding: 0.75em;
  color:  var(--color-text);
  cursor: pointer;
  transition: 0.2s linear;
}
.title-settings {
  font-size: 14px;
  color: var(--color-text);
  margin: 16px 0px;
}
.title-box-links {
  font-size: 12px;
  color: var(--color-text);
  margin-top: 12px;
  margin-bottom: 5px !important;
}
.rotate-180 {
  transform: rotate(180deg);
  transition: 0.2s linear;
}
.content-bottom-setting {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 25px 5px;
  padding: 9px;
  border-radius: 5px;
  /* box-shadow: -8px -4px 13px rgba(var(--color-box-shadow-rgb), 0.2); */
  border: 1px solid var(--border-color);
  width: 98%;
  
}
.content-mode-theme {
  /* margin-top: 15px;
  height: 40px; */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  color: var(--color-text);
}
.content-mode-theme  #icon-theme {
  width: 40px;
  font-size: 16px;
  cursor: pointer;
}
/* body.rtl .sidebar {
  left: unset;
  right: 0;
} */
.locale-changer {
  position: relative;
  width: 100%;
  border: 1px solid var(--color-text);
  margin-bottom: 12px;
  border-radius: 5px;
}
.locale-changer select {
  border: unset;
  width: 96%;
  color: var(--color-text);
  outline: unset;
  background: transparent;
  height: 22px;
}
.locale-changer select option {
  margin: 40px;
  background: var(--box-background);
  color: var(--color-text);
  text-shadow: unset;
}
/* body.rtl .content-mode-theme {
  right: unset;
  left: -20px;
  box-shadow: -8px -4px 13px rgba(var(--color-box-shadow-rgb), 0.2);
} */
body.rtl .sidebar {
  left: unset;
  right: -400px;
  float: right;
}
body.rtl .sidebar.show {
  left: unset;
  right: 0px;
  float: right;
}
</style>
  